import { getStore } from '../store/index';

const FORMDATA_KEY = 'TuDiCorrelationId';
const hasLoadedTUDigitalIdentityScripts = {
  current: false,
};

const isStateValid = (state) => {
  return (
    state &&
    state.formData &&
    state.formMeta &&
    state.formData[FORMDATA_KEY] == null
  );
};

const init = async () => {
  if (hasLoadedTUDigitalIdentityScripts.current === false) {
    await require('./nsr_handshake.js');
    hasLoadedTUDigitalIdentityScripts.current = true;
  }
  const store = getStore();
  const state = store.getState();
  if (isStateValid(state)) {
    await callNsrHandshake();
  }
};

const onSuccess = (result) => {
  if (result) {
    const store = getStore();
    const state = store.getState();

    // Ensure extraDataFields exists before setting the correlation ID
    const extraDataFields = state.formData.extraDataFields || {};

    store.dispatch(
      window.formActions.change('formData.extraDataFields', {
        ...extraDataFields,
        [FORMDATA_KEY]: result,
      })
    );
  }
};

const onFail = (sessionId, error) => {
  const store = getStore();
  const state = store.getState();

  // Ensure extraDataFields exists before setting the fallback formUuid
  const extraDataFields = state.formData.extraDataFields || {};
  const correlationId = state.formMeta?.formUuid || sessionId;
  store.dispatch(
    window.formActions.change('formData.extraDataFields', {
      ...extraDataFields,
      [FORMDATA_KEY]: correlationId,
    })
  );
  console.log(sessionId, error);
};

const callNsrHandshake = async () => {
  try {
    const result = await new Promise((resolve, reject) => {
      window._nsr_handshake(undefined, resolve, (sessionId, error) => {
        reject({ sessionId, error });
      });
    });
    onSuccess(result);
  } catch (errorData) {
    const { sessionId, error } = errorData;
    onFail(sessionId, error);
  }
};

window.initTUDigitalIdentity = Object.freeze(init);
